var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('menuBar'),_c('banner',{attrs:{"mobile":_vm.mobile}}),_c('recommend',{attrs:{"mobile":_vm.mobile}}),_c('whychooseScad'),_c('custFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }